import { API } from "../../../utils";

export const getDashboardSalesGraph = async (start_date, end_date) => {
  const res = await API.get(
    `kpi/sales-by-day?start=${start_date}&end=${end_date}`,
  );
  return res.data;
};

export const getDashboardCards = async (start_date, end_date) => {
  const res = await API.get(`kpi/summary?start=${start_date}&end=${end_date}`);
  return res.data;
};

export const getDashboardStoreSales = async (start_date, end_date) => {
  const res = await API.get(
    `kpi/sales-by-store?start=${start_date}&end=${end_date}`,
  );
  return res.data;
};
